import React from 'react';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';

type ToggleIconProps = {
  isActive: boolean;
  isDisabled?: boolean;
};
export const ToggleIcon = ({
  isActive,
  isDisabled = false,
}: ToggleIconProps) => {
  return isActive ? (
    <Icon
      icon="toggle-on"
      color={isDisabled ? colors.gray[200] : colors.blue[400]}
      type="solid"
      size="large"
    />
  ) : (
    <Icon
      icon="toggle-off"
      color={isDisabled ? colors.gray[200] : colors.black[60]}
      size="large"
    />
  );
};
